// src/pages/invoicing/pi-view.js
import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import API_BASE_URL from "../../config";
import { useParams } from "react-router-dom";
import Header from "../../components/Header";
import { Button } from "react-bootstrap";

const TIView = () => {
  const { id } = useParams(); // PI ID from URL like /pi-view/25600
  const [invoice, setInvoice] = useState(null);
  const [lineItems, setLineItems] = useState([]);
  const [brand, setBrand] = useState(null);
  const [billing, setBilling] = useState(null);

  useEffect(() => {
    document.title = "Tax Invoice View | Webyappy";

    // Force viewport to desktop width
    const viewport = document.querySelector('meta[name="viewport"]');
    if (viewport) {
      viewport.setAttribute("content", "width=1024");
    }

    fetchInvoiceData(id);

    // Optionally revert on unmount
    return () => {
      if (viewport) {
        viewport.setAttribute("content", "width=device-width, initial-scale=1");
      }
    };
  }, [id]);

  const fetchInvoiceData = async (ti_id) => {
    console.log("🔍 Running fetchInvoiceData for TI ID:", ti_id);
    try {
      // Step 1: Fetch main proforma invoice
      const piRes = await fetch(`${API_BASE_URL}/invoicing/get_ti/${ti_id}`, {
        credentials: "include",
      });
      const piData = await piRes.json();
      if (piData.status !== "success") throw new Error("PI not found");
      setInvoice(piData.invoice);

      // Step 2: Fetch line items
      const itemRes = await fetch(
        `${API_BASE_URL}/invoicing/get_ti_items/${ti_id}`,
        {
          credentials: "include",
        },
      );
      const itemData = await itemRes.json();
      if (itemData.status === "success") setLineItems(itemData.items);

      // Step 3: Fetch brand info
      // Step 3: Fetch brand info by ID
      if (piData.invoice.brand_id) {
        const brandRes = await fetch(
          `${API_BASE_URL}/invoicing/get_brand_by_id/${piData.invoice.brand_id}`,
          {
            credentials: "include",
          },
        );
        const brandData = await brandRes.json();
        if (brandData.status === "success") {
          setBrand(brandData.brand);
          console.log("✅ Brand data received:", brandData.brand);
        } else {
          console.warn("⚠️ Brand not found for ID:", piData.invoice.brand_id);
        }
      } else {
        console.warn("⚠️ No brand_id in invoice.");
      }

      // Step 4: Fetch billing address
      const billingRes = await fetch(
        `${API_BASE_URL}/invoicing/get_billing_address`,
        {
          credentials: "include",
        },
      );
      const billingData = await billingRes.json();
      if (billingData.status === "success")
        setBilling(billingData.billing_address);
      console.log("📦 Billing Data:", billingData.billing_address);
    } catch (err) {
      console.error("Failed to fetch invoice:", err);
    }
  };

  return (
    <>
      <Header />
      <div style={{ paddingTop: "70px", paddingBottom: "70px" }}>
        <div className="container-fluid px-3 py-3">
          <div className="d-flex align-items-center justify-content-between mb-4">
            <ul className="breadcrumb breadcrumb-transparent breadcrumb-dot font-weight-bold mb-0 p-0">
              <li className="breadcrumb-item">
                <Link to="/home" className="text-muted">
                  Home
                </Link>
              </li>
              <li className="breadcrumb-item">
                <Link to="/pages/invoicing/Invoicing" className="text-muted">
                  Invoicing
                </Link>
              </li>
              <li className="breadcrumb-item">
                <span className="text-dark font-weight-bold">Tax Invoice</span>
              </li>
            </ul>
          </div>
          <div className="row bg-white border rounded p-2 mb-3">
            <div className="col-lg-4 col-md-4 align-self-center">
              <h5 className="mb-0">
                <i
                  className="fas fa-check-circle icon-lg text-success"
                  style={{ marginRight: "10px" }}
                ></i>
                Tax Invoice Generated
              </h5>
            </div>
            <div className="col-lg-8 col-md-8 text-right">
              <div className="d-flex flex-wrap justify-content-end">
                {/* <div className="btn-group" style={{ marginRight: "10px" }}>
                  <button type="button" className="btn btn-sm btn-primary">
                    <i className="far fa-image"></i> Download IMG
                  </button>
                </div> */}
                <div className="btn-group">
                  <Button
                    className="btn btn-sm btn-light-primary font-weight-bold"
                    onClick={() =>
                      window.open(
                        `/pages/invoicing/ti-print/${invoice.id}`,
                        "_blank",
                      )
                    }
                  >
                    Download PDF
                  </Button>
                </div>
              </div>
            </div>
          </div>
          {invoice && (
            <div className="col-lg-8 mx-auto">
              <div
                className="card card-custom shadow-sm px-5 py-5"
                id="invoiceArea"
              >
                {/* Step 1: Company & Billing Address */}
                {billing && (
                  <div className="bg-light p-3">
                    <div className="">
                      <h3
                        className="font-weight-bold text-uppercase mb-1"
                        style={{ color: "#003366" }}
                      >
                        TAX INVOICE
                      </h3>
                      <div className="d-flex justify-content-between align-items-start mb-3">
                        <div style={{ maxWidth: "70%" }}>
                          <h6
                            className="font-weight-bold text-uppercase mb-1"
                            style={{
                              color: brand?.color_code || "#000",
                              fontWeight: "bold",
                            }}
                          >
                            {billing.company_name}
                          </h6>

                          <p className="mb-1">{billing.address}</p>
                          <p className="mb-1">
                            {billing.state}, {billing.city} - {billing.pincode}
                          </p>
                          <p className="mb-1">GSTIN: {billing.gst}</p>
                          <p className="mb-1">PAN: {billing.pan}</p>
                          <p className="mb-1">CIN: {billing.cin}</p>
                          <p className="mb-1">{billing.email}</p>
                          <p className="mb-0">{billing.mobile}</p>
                        </div>

                        {brand?.logo && (
                          <img
                            src={
                              brand.logo.startsWith("http")
                                ? brand.logo
                                : `${API_BASE_URL.replace("/index.php", "")}/${brand.logo}`
                            }
                            alt={brand.brand_name}
                            style={{
                              maxHeight: "200px", // ✅ Fits in header nicely
                              maxWidth: "250px", // ✅ Prevents very wide logos from breaking layout
                              width: "auto",
                              height: "auto",
                              objectFit: "contain", // ✅ Keeps proportions without stretching
                              display: "block",
                            }}
                          />
                        )}
                      </div>
                    </div>
                  </div>
                )}
                {invoice && (
                  <div className="mt-3 p-3">
                    <div className="d-flex justify-content-between align-items-start mb-3">
                      {/* TO Section */}
                      <div style={{ maxWidth: "60%" }}>
                        <h6
                          className="font-weight-bold text-uppercase mb-1"
                          style={{
                            color: brand?.color_code,
                            fontWeight: "bold",
                          }}
                        >
                          TO,
                        </h6>

                        <p
                          className="mb-1 text-uppercase"
                          style={{ fontWeight: "bold", color: "#003366" }}
                        >
                          {invoice.to_company}
                        </p>
                        <p className="mb-1" style={{ color: "#003366" }}>
                          {invoice.to_address}
                        </p>
                        <p className="mb-1" style={{ color: "#003366" }}>
                          {invoice.to_city}, {invoice.to_state} -{" "}
                          {invoice.to_pincode}
                        </p>
                        {invoice.to_gstin && (
                          <p className="mb-0" style={{ color: "#003366" }}>
                            GSTIN: {invoice.to_gstin}
                          </p>
                        )}
                      </div>

                      {/* PI Info */}
                      <div
                        className="text-right"
                        style={{ marginRight: "50px" }}
                      >
                        <p className="mb-1">
                          <strong style={{ color: brand?.color_code }}>
                            No
                          </strong>
                          :<br /> {invoice.ti_no}
                        </p>
                        <p className="mb-0">
                          <strong style={{ color: brand?.color_code }}>
                            Date
                          </strong>
                          : <br />{" "}
                          {new Date(invoice.created_on).toLocaleDateString(
                            "en-IN",
                            {
                              day: "2-digit",
                              month: "short",
                              year: "numeric",
                            },
                          )}
                        </p>
                      </div>
                    </div>
                  </div>
                )}
                {/* Step 2: Styled Line Items Table */}
                <div className="px-2">
                  <table className="w-100" style={{ fontSize: "15px" }}>
                    <thead>
                      <tr>
                        <td colSpan="5">
                          <hr
                            style={{
                              borderTop: "2px dotted #999",
                              margin: "4px 0 10px 0",
                              borderBottom: "none",
                            }}
                          />
                        </td>
                      </tr>
                      <tr
                        style={{
                          color: brand?.color_code || "#FF6600",
                          fontWeight: "bold",
                          textTransform: "uppercase",
                        }}
                      >
                        <th className="text-left" style={{ width: "5%" }}>
                          No
                        </th>
                        <th className="text-left" style={{ width: "9%" }}>
                          SAC
                        </th>
                        <th className="text-left" style={{ width: "62%" }}>
                          Description
                        </th>
                        <th className="text-left" style={{ width: "10%" }}>
                          Tax (%)
                        </th>
                        <th className="text-left" style={{ width: "13%" }}>
                          Amount
                        </th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr>
                        <td colSpan="5">
                          <hr
                            style={{
                              borderTop: "2px dotted #999",
                              margin: "4px 0 10px 0",
                              borderBottom: "none",
                            }}
                          />
                        </td>
                      </tr>
                      {lineItems.map((item, index) => (
                        <tr
                          key={index}
                          style={{ color: "#003366", verticalAlign: "top" }}
                        >
                          <td className="text-left">{index + 1}</td>
                          <td className="text-left">{item.sac_code}</td>
                          <td
                            className="text-left"
                            style={{ paddingRight: "10px" }}
                          >
                            {item.title}
                          </td>
                          <td className="text-left">
                            {parseInt(item.gst_percent)}
                          </td>
                          <td className="text-right">
                            ₹{parseFloat(item.amount).toLocaleString("en-IN")}
                          </td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                </div>

                {/* Step 3: Payment Details + Totals Summary */}
                <div
                  className="bg-light p-4 mt-4 d-flex justify-content-between align-items-start"
                  style={{ fontSize: "15px" }}
                >
                  {/* Left: Bank Details */}
                  <div style={{ maxWidth: "60%" }}>
                    <p
                      className="font-weight-bold mb-2"
                      style={{ color: "#003366" }}
                    >
                      <strong>For NEFT / IMPS</strong>
                    </p>
                    <p className="mb-1 font-weight-bold">
                      {billing?.company_name}
                    </p>
                    <p className="mb-1">ICICI Bank</p>
                    <p className="mb-1">Vashi Branch</p>
                    <p className="mb-1">A/C: 015105013645</p>
                    <p className="mb-0">IFSC: ICIC0000151</p>
                  </div>

                  {/* Right: Amount Summary (non-table version) */}
                  <div
                    className="bg-light px-4 py-4 text-right"
                    style={{
                      minWidth: "250px",
                      fontSize: "15px",
                      color: "#003366",
                      textAlign: "right",
                    }}
                  >
                    <div className="font-weight-bold mb-2">
                      SUBTOTAL: ₹
                      {parseFloat(invoice.subtotal).toLocaleString("en-IN")}
                    </div>

                    {parseFloat(invoice.igst) > 0 ? (
                      <div className="mb-2">
                        IGST on{" "}
                        {parseFloat(invoice.subtotal).toLocaleString("en-IN")} @{" "}
                        {Math.round(
                          (parseFloat(invoice.igst) * 100) /
                            parseFloat(invoice.subtotal),
                        )}
                        % : ₹{parseFloat(invoice.igst).toLocaleString("en-IN")}
                      </div>
                    ) : (
                      <>
                        <div className="mb-2">
                          CGST on{" "}
                          {parseFloat(invoice.subtotal).toLocaleString("en-IN")}{" "}
                          @{" "}
                          {Math.round(
                            (parseFloat(invoice.cgst) * 100) /
                              parseFloat(invoice.subtotal),
                          )}
                          % : ₹
                          {parseFloat(invoice.cgst).toLocaleString("en-IN")}
                        </div>

                        <div className="mb-2">
                          SGST on{" "}
                          {parseFloat(invoice.subtotal).toLocaleString("en-IN")}{" "}
                          @{" "}
                          {Math.round(
                            (parseFloat(invoice.sgst) * 100) /
                              parseFloat(invoice.subtotal),
                          )}
                          % : ₹
                          {parseFloat(invoice.sgst).toLocaleString("en-IN")}
                        </div>
                      </>
                    )}

                    <div className="my-2">
                      <hr
                        style={{
                          borderTop: "2px dotted #999",
                          margin: "10px 0",
                        }}
                      />
                    </div>

                    <div
                      className="font-weight-bold text-uppercase"
                      style={{ fontSize: "14px" }}
                    >
                      Total Amount
                    </div>

                    <div
                      className="font-weight-bolder"
                      style={{
                        fontSize: "22px",
                        color: brand?.color_code || "#FF6600", // ✅ Use brand color
                      }}
                    >
                      ₹
                      <strong>
                        {Math.round(
                          parseFloat(invoice.grand_total),
                        ).toLocaleString("en-IN")}
                      </strong>
                    </div>
                  </div>
                </div>
                {invoice?.status === "Paid" && (
                  <div className="mt-4 d-flex align-items-center justify-content-between">
                    {/* Left side: PAID */}
                    <img
                      src="assets/logos/paid.png"
                      alt="PAID"
                      style={{
                        width: "100px",
                        opacity: 0.9,
                      }}
                    />

                    {/* Right side: Company Stamp */}
                    <img
                      src="assets/logos/stamp.png"
                      alt="Company Stamp"
                      style={{
                        width: "150px",
                        opacity: 0.85,
                      }}
                    />
                  </div>
                )}

                {invoice?.reference_pi_no && (
                  <p
                    className=" mb-0 font-weight-bold"
                    style={{ color: "#003366" }}
                  >
                    Against {invoice.reference_pi_no}
                  </p>
                )}
              </div>
            </div>
          )}
        </div>
      </div>
    </>
  );
};

export default TIView;
